var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BorderTitle',[_vm._v(" "+_vm._s(_vm.item.title))]),_c('div',{staticClass:"margin10"}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.item.content)}}),_c('div',{staticClass:"margin10"}),_c('BorderTitle',[_vm._v("适用范围")]),_c('div',{staticClass:"margin10"}),_c('DiseaseTag',{attrs:{"type":"wx","list":_vm.tagList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }